import { Edition } from '@atlassian/touchpoint-commons-event-analytics';

import type { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	dialogId: 'user-limit-direct-buy-modal',
	dialogType: 'modal',
	touchpointIntent: 'changePlan',
	targetProductEdition: Edition.STANDARD_EDITION,
};
